module.exports = __webpack_public_path__ + "static/media/paraguay.5b895dc2.svg";